// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiMenu-paper {
	padding: 4px 6px;
	border-radius: 8px !important;
	background: #fff;
	box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.12) !important;
}
.menu-item-el {
	display: flex;
	justify-content: flex-start;
	width: 110px;
	gap: 0 6px;
	padding: 6px !important;
	margin-bottom: 5px !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/MenuDropdown/menu.m.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,6BAA6B;CAC7B,gBAAgB;CAChB,0DAA0D;AAC3D;AACA;CACC,aAAa;CACb,2BAA2B;CAC3B,YAAY;CACZ,UAAU;CACV,uBAAuB;CACvB,6BAA6B;AAC9B","sourcesContent":[".MuiMenu-paper {\n\tpadding: 4px 6px;\n\tborder-radius: 8px !important;\n\tbackground: #fff;\n\tbox-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.12) !important;\n}\n.menu-item-el {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\twidth: 110px;\n\tgap: 0 6px;\n\tpadding: 6px !important;\n\tmargin-bottom: 5px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
